import Slider from '../Slider';
import PosterReel from './PosterReel';

import styles from './reels.module.scss';

const ReelsSkeleton = (props) => {
    const { titol, skeletonItems } = props;

    return (
        <div className={styles.contReel}>
            <Slider format='poster-reel' titol={titol}>
                {Array.from({ length: skeletonItems }, (_, index) => (
                    <PosterReel key={`poster-reel-skeleton-${index}`} isLoading={true} />
                ))}
            </Slider>
        </div>
    );
};

ReelsSkeleton.defaultProps = {
    skeletonItems: 4
};

export default ReelsSkeleton;
